var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 65,
  viewBox: "0 0 60 65",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFC300",
  d: "M29.994 65 0 42.71V31.575l17.269 3.893 12.738 17.729 12.718-17.73 17.27-3.892H60V42.71z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 5.652v25.923h.004l29.993-16.873S7.523 1.622 5.6.85C1.99-.62 0-.836 0 5.652Z",
  fill: "#FF8D00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.398.85c-1.923.773-24.333 13.812-24.333 13.812L.004 31.575l17.27 3.893 12.72 17.729 12.745-17.73L60 31.576V5.652C60-.836 58.011-.619 54.398.85Z",
  fill: "#FF4F00"
}))));

export default SvgLogo;